export default __webpack_public_path__ + "static/media/broken-bone.1d2eb2be.png";